import React from "react";
import SbEditable from "storyblok-react";
import FluidImage from "src/utils/FluidImage";
import Heading from "src/components/Heading";

const HeroVideo = ({ blok }) => {
  const isVideo =
    blok.desktop_asset?.filename?.includes(".mp4") &&
    blok.mobile_asset?.filename?.includes(".mp4");

  return (
    <SbEditable content={blok} key={blok._uid}>
      <div className="relative h-screen overflow-hidden">
        <div className="w-full h-full grid grid-cols-1 grid-rows-1">
          <div className="row-start-1 col-start-1">
            {!isVideo && (
              <>
                <FluidImage
                  className="w-full h-full object-cover lg:block hidden"
                  image={blok.desktop_asset}
                />
                <FluidImage
                  className="w-full h-full object-cover lg:hidden block"
                  image={blok.mobile_asset}
                />
              </>
            )}
            {isVideo && (
              <div className="block w-full h-full object-cover">
                <video
                  width="1920"
                  height="1080"
                  muted
                  controlsList="nodownload"
                  autoPlay
                  loop
                  playsInline
                  className="lg:block hidden w-full h-full object-cover"
                >
                  <source src={blok.desktop_asset.filename} type="video/mp4" />
                  Sorry, your browser doesn't support embedded videos.
                </video>
                <video
                  width="1920"
                  height="1080"
                  muted
                  controlsList="nodownload"
                  autoPlay
                  loop
                  playsInline
                  className="lg:hidden block w-full h-full object-cover"
                >
                  <source src={blok.mobile_asset.filename} type="video/mp4" />
                  Sorry, your browser doesn't support embedded videos.
                </video>
              </div>
            )}
          </div>
          {/* Text */}
          <div className="row-start-1 col-start-1 z-10">
            <div className="relative max-w-7xl mx-auto px-6 h-full flex flex-col justify-center items-start">
              <div className="flex flex-col lg:flex-row w-full lg:items-center">
                <Heading size="h1" className="text-white max-w-4xl">
                  {blok.title}
                </Heading>
              </div>
            </div>
          </div>
          {/* Contact Us anchor box */}
          <div className="row-start-1 col-start-1 z-10">
            <a
              href="#contact-us"
              className="absolute bottom-0 right-0 py-3 px-4 bg-royal_depths text-white"
            >
              <div className="flex justify-center items-center gap-2">
                <div className="w-5 h-5">
                  <svg
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M17.6168 15.2731H9.41387L4.72648 18.7887V15.2731H2.38279C2.072 15.2731 1.77392 15.1497 1.55416 14.9299C1.3344 14.7102 1.21094 14.412 1.21094 14.1013V2.38279C1.21094 2.072 1.3344 1.77392 1.55416 1.55416C1.77392 1.3344 2.072 1.21094 2.38279 1.21094H17.6168C17.9276 1.21094 18.2257 1.3344 18.4455 1.55416C18.6652 1.77392 18.7887 2.072 18.7887 2.38279V14.1013C18.7887 14.412 18.6652 14.7102 18.4455 14.9299C18.2257 15.1497 17.9276 15.2731 17.6168 15.2731Z"
                      fill="#FA632A"
                    />
                    <path
                      d="M9.99999 8.53514C9.8382 8.53514 9.70703 8.40398 9.70703 8.24218C9.70703 8.08038 9.8382 7.94922 9.99999 7.94922"
                      stroke="#202A9D"
                      stroke-width="1.5"
                    />
                    <path
                      d="M10 8.53514C10.1618 8.53514 10.293 8.40398 10.293 8.24218C10.293 8.08038 10.1618 7.94922 10 7.94922"
                      stroke="#202A9D"
                      stroke-width="1.5"
                    />
                    <path
                      d="M6.48437 8.53514C6.32257 8.53514 6.19141 8.40398 6.19141 8.24218C6.19141 8.08038 6.32257 7.94922 6.48437 7.94922"
                      stroke="#202A9D"
                      stroke-width="1.5"
                    />
                    <path
                      d="M6.48438 8.53514C6.64618 8.53514 6.77734 8.40398 6.77734 8.24218C6.77734 8.08038 6.64618 7.94922 6.48438 7.94922"
                      stroke="#202A9D"
                      stroke-width="1.5"
                    />
                    <path
                      d="M13.5156 8.53514C13.3538 8.53514 13.2227 8.40398 13.2227 8.24218C13.2227 8.08038 13.3538 7.94922 13.5156 7.94922"
                      stroke="#202A9D"
                      stroke-width="1.5"
                    />
                    <path
                      d="M13.5156 8.53514C13.6774 8.53514 13.8086 8.40398 13.8086 8.24218C13.8086 8.08038 13.6774 7.94922 13.5156 7.94922"
                      stroke="#202A9D"
                      stroke-width="1.5"
                    />
                  </svg>
                </div>
                <div className="flex gap-1">
                  <div className="text-base">Need help now?</div>
                  <div className="w-5 h-5">
                    <svg
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10 4V16"
                        stroke="white"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M14 12.8335L10 16.8335L6 12.8335"
                        stroke="white"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </SbEditable>
  );
};

export default HeroVideo;
